/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import { React, useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Modal, Drawer, AppBar, ListItemAvatar, Avatar, Toolbar, Typography, TextField, Button, Paper, List, ListItem, ListItemText } from "@mui/material";
import ProjkeyCard from "./components/projkeycard";
import Projkeyform from "./components/projkeyform";
import {
  getkeys,
  savekey,
  getOrganizations,
  deleteKey
} from "context";

const drawerWidth = 240;


function Keys() {
  const [open, setOpen] = useState(false);
  const [Projkeys , setProjkeys] = useState([]);
  const handleOpen = () => {
    setOpen(true)
    setprojkey(null);
  }
  const handleClose = () => setOpen(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [projkey, setprojkey] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  useEffect(() => {
    Fetchkeys()
  }, [])
  const Fetchkeys =  async () => {
    let response = await getkeys();
    setProjkeys(response.data.resp)
  }
  const editForm = (key) => {
    setorg(key);
    setOpen(true);
  }
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
 const handleEdit = () => {
    handleMenuClose();
    onEdit();
  };

  // const handleDelete = () => {
  //   handleMenuClose();
  //   onDelete();
  // };

  const handleSave = async (keyData) => {
    // Call saveOrganizations and refresh data
    const response = await savekey(keyData);
    Fetchkeys(); // Refresh after save
    handleClose();
  };

  const handleDelete = async (key) => {
    // Call deleteOrganization and refresh data
    await deleteKey(key);
    Fetchkeys(); // Refresh after delete
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <Grid spacing={12} sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}>
          <MDButton color={"info"} onClick={handleOpen} >ADD new </MDButton>
        </Grid>
      </MDBox>
      <MDBox sx={{ minHeight:"75vh"  }}>
        <Grid container spacing={3} mt={1}>
         {
            Projkeys.map((value) => (
                <Grid item xs={4} key={value.id} >
                  <ProjkeyCard keyData={value} deleteKey={handleDelete} />

                </Grid>
            )
            )
          }
        </Grid>
      </MDBox>

      <Modal open={open} onClose={handleClose}>
       <Projkeyform  projkeyData={projkey}  saveProjkey={handleSave} getOrganizations={getOrganizations} />
      </Modal>
      <Footer />
    </DashboardLayout>
  );
}

export default Keys;
